import moment from 'moment';

export function getNowDate() {
    let oDate = new Date();
    let year = oDate.getFullYear();
    let month = oDate.getMonth() + 1;
    let date = oDate.getDate();

    if (month < 10) {
        month = '0' + parseInt(month) || 0;
    }

    if (date < 10) {
        date = '0' + parseInt(date) || 0;
    }

    return year + '/' + month + '/' + date;
}

export function getDate(param) {
    if (!param) {
        return '';
    }

    let oDate = new Date(param);
    let year = oDate.getFullYear();
    let month = oDate.getMonth() + 1;
    let date = oDate.getDate();

    let sDateTime = '';

    if (month < 10) {
        month = '0' + parseInt(month) || 0;
    }

    if (date < 10) {
        date = '0' + parseInt(date) || 0;
    }

    sDateTime = year + '/' + month + '/' + date;

    return sDateTime;
}

export function getDateTime(param, showSecond) {
    if (!param) {
        return '';
    }

    let oDate = new Date(param);
    let year = oDate.getFullYear();
    let month = oDate.getMonth() + 1;
    let date = oDate.getDate();
    let hour = oDate.getHours();
    let minit = oDate.getMinutes();
    let second = oDate.getSeconds();

    let sDateTime = '';

    if (month < 10) {
        month = '0' + parseInt(month) || 0;
    }

    if (date < 10) {
        date = '0' + parseInt(date) || 0;
    }

    if (hour < 10) {
        hour = '0' + parseInt(hour) || 0;
    }

    if (minit < 10) {
        minit = '0' + parseInt(minit) || 0;
    }

    if (second < 10) {
        second = '0' + parseInt(second) || 0;
    }

    sDateTime = year + '/' + month + '/' + date;

    sDateTime += ' ' + hour + ':' + minit;

    if (showSecond) {
        sDateTime += ':' + second;
    }

    return sDateTime;
}

/**
 * 校验是否是有效的日期
 * @param {Number} year 年
 * @param {Number} month 月
 * @param {Number} date 日
 */
export function checkDate(year, month, date) {
    // 这种检验日期的方式,date必须是两位,month可以是一位
    if (parseInt(date) < 10) {
        date = '0' + date;
    }
    let sCheckDate = year + '/' + month + '/' + date;
    return parseInt(new Date(sCheckDate).getDate()) === parseInt(sCheckDate.substring(sCheckDate.length - 2));
}

/**
 * moment 处理
 */
export function fnMomentHandle(str, format = 'YYYY/MM/DD') {
    if (!str) {
        return '';
    }

    const arr = str.split(/\D/);
    const iYear = parseInt(arr[0]) || 0;
    const iMonth = parseInt(arr[1]) || 0;
    const iDate = parseInt(arr[2]) || 0;

    if (iYear > 2100 || iYear < 1900) {
        return '';
    }

    let sDate = '';
    if (iYear) {
        sDate += iYear;
    }
    if (iMonth) {
        sDate += '/' + iMonth;
    }
    if (iMonth && iDate) {
        sDate += '/' + iDate;
    }
    return moment(sDate, format);
}

/**
 * 获取 moment 日期
 */
export function getMomentDate(param, format = 'YYYY/MM/DD') {
    if (!param) {
        return '';
    }
    return param.format(format);
}
